import React, { memo } from 'react';
import { useStyles } from './styles';

function Divider() {
  const styles = useStyles();
  return <div className={styles.divider} aria-label="divider" />;
}

export default memo(Divider);
